<div class="detail-box">
  <div class="column-list" style="padding:8px;">

    <label class="list-input-title">使用開始受注コード</label>
    <div class="list-input-content">
      <app-order-code-text-input id="txi_StartOrderCode" [forcedEnabledMode]="'false'"
        #txi_StartOrderCode [subid]="'txi_StartOrderCode'" [disabled]="true">
      </app-order-code-text-input>
    </div>

    <label class="list-input-title">使用終了受注コード</label>
    <div class="list-input-content">
      <app-order-code-text-input id="txi_EndOrderCode1" [forcedEnabledMode]="'false'" [tabindex]="0" #txi_EndOrderCode1
        [subid]="'txi_EndOrderCode1'" [disabled]="true">
      </app-order-code-text-input>
    </div>

    <div></div>
    <div class="list-input-content">
      <select id="cmb_EndOrderCode2" forcedEnabledMode="false" [(ngModel)]="endOrderCode2" [tabindex]="0"
        #cmb_EndOrderCode2 [disabled]="disabledFlag">
        <ng-template ngFor let-item [ngForOf]="this.endOrderCode2_dataProvider">
          <option value="{{item.data}}">{{item.label}}</option>
        </ng-template>
      </select>
    </div>

    <label class="list-input-title">画像名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageName" #lbl_ImageName value="{{imageName}}" readonly>
    </div>

    <label class="list-input-title">画像ファイル名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageFileName" #lbl_ImageFileName value="{{imageFileName}}" readonly>
    </div>

    <label class="list-input-title">所属</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageBelongName" #lbl_ImageBelongName value="{{imageBelongName}}" readonly>
    </div>

    <label class="list-input-title">画像種類</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageKindName" #lbl_ImageKindName value="{{imageKindName}}" readonly>
    </div>

    <label class="list-input-title">画像種別</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageTypeName" #lbl_ImageTypeName value="{{imageTypeName}}" readonly>
    </div>

    <label class="list-input-title">調理指示</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_ProcessInstruct" [codeDiv]="'ct368'" forcedEnabledMode="false" [tabindex]="0"
        [labelField]="'codeValueName'" #cmb_ProcessInstruct [subid]="'cmb_ProcessInstruct'"
        (change)="eventImageInfoDetailCHANGE.emit($event)">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">備考</label>
    <div class="list-input-content">
      <app-text-area [fullOnly]="true" id="txi_Remarks" [forcedEnabledMode]="'false'" [tabindex]="0" [maxChars]="128"
        [restrict]="'[ -￮]'" [verticalScrollPolicy]="'on'" horizontalScrollPolicy="off" #txi_Remarks
        [subid]="'txi_Remarks'" [(ngModel)]="remarks" [disabled]="disabledFlag" [displayCountField]="false"
        (input)="eventImageInfoDetailCHANGE.emit($event)">
      </app-text-area>
    </div>

    <label class="list-input-title">調理例掲載区分</label>
    <div class="list-input-content">
      <input type="checkbox" id="ckb_CookingExPublish" forcedEnabledMode="false"
      #ckb_CookingExPublish [(ngModel)]="cookingExPublish">
    </div>

    <label class="list-input-title">優先度</label>
    <div class="list-input-content">
      <app-text-input [halfOnly]="true" id="txi_Priority" [maxChars]="2" [forcedEnabledMode]="'false'"
      [tabindex]="0" [restrict]="'[0-9]'" #txi_Priority [subid]="'txi_Priority'" [(ngModel)]="priority"
      [displayCountField]="false" [disabled]="disabledFlag">
    </app-text-input>
    </div>

    <label class="list-input-title">Ｐコード</label>
    <div class="list-input-content">
      <input type="text" id="lbl_Pcode" #lbl_Pcode value="{{pcode}}" readonly>
    </div>

    <label class="list-input-title">商品名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_GuideGoodsName" #lbl_GuideGoodsName value="{{ guideGoodsName }}" readonly>
    </div>

    <label class="list-input-title">規格名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_GuideStandardName" #lbl_GuideStandardName value="{{guideStandardName}}" readonly>
    </div>

    <label class="list-input-title">料理分類</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_CookingDiv" [codeDiv]="'ct369'"
      [forcedEnabledMode]="'false'" [labelField]="'codeValueName'" #cmb_CookingDiv [subid]="'cmb_CookingDiv'"
      [tabindex]="0" [disabled]="disabledFlag" (change)="eventImageInfoDetailCHANGE.emit($event)">
    </app-code-combo-box>
    </div>

    <label class="list-input-title">料理名</label>
    <div class="list-input-content">
      <app-text-input id="txi_CookingName" [maxChars]="20" [restrict]="'[ -￮]'" #txi_CookingName
      [subid]="'txi_CookingName'" [disabled]="disabledFlag" (input)="eventImageInfoDetailCHANGE.emit($event)"
      [(ngModel)]="cookingName" [tabindex]="0" [displayCountField]="false">
    </app-text-input>
    </div>

    <label class="list-input-title">材料名</label>
    <div class="list-input-content">
      <app-text-input id="txi_MaterialName" [forcedEnabledMode]="'false'" [tabindex]="0" [maxChars]="20"
      [restrict]="'[ -￮]'" #txi_MaterialName [subid]="'txi_MaterialName'" [(ngModel)]="materialName"
      [displayCountField]="false" [disabled]="disabledFlag"
      (input)="eventImageInfoDetailCHANGE.emit($event)"></app-text-input>
    </div>

    <label class="list-input-title">キーワード</label>
    <div class="list-input-content">
      <app-text-area [fullOnly]="true" id="txi_KeyWord" [forcedEnabledMode]="'false'" [tabindex]="0"
      [maxChars]="128" [restrict]="'[ -￮]'" #txi_KeyWord [subid]="'txi_KeyWord'" [displayCountField]="false"
      [(ngModel)]="keyWord" [disabled]="disabledFlag" (input)="eventImageInfoDetailCHANGE.emit($event)">
    </app-text-area>
    </div>

    <label class="list-input-title">催事・季節</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_EventId" [codeDiv]="'ct370'"
      [forcedEnabledMode]="'false'" [labelField]="'codeValueName'" #cmb_EventId [subid]="'cmb_EventId'"
      [tabindex]="0" [disabled]="disabledFlag" (change)="eventImageInfoDetailCHANGE.emit($event)">
    </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影内容区分</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_PhotoContentsDiv" [codeDiv]="'ct372'"
      [forcedEnabledMode]="'false'" [labelField]="'codeValueName'" #cmb_PhotoContentsDiv
      [subid]="'cmb_PhotoContentsDiv'" [tabindex]="0" [disabled]="disabledFlag"
      (change)="eventImageInfoDetailCHANGE.emit($event)">
    </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影指示内容</label>
    <div class="list-input-content">
      <app-text-area [fullOnly]="true" id="txi_PhotoInstructContents" [forcedEnabledMode]="'false'"
      [tabindex]="0" [maxChars]="128" [restrict]="'[ -￮]'" #txi_PhotoInstructContents
      [subid]="'txi_PhotoInstructContents'" [displayCountField]="false" [(ngModel)]="photoInstructContents"
      [disabled]="disabledFlag" (input)="eventImageInfoDetailCHANGE.emit($event)"></app-text-area>
    </div>

    <label class="list-input-title">撮影予定日</label>
    <div class="list-input-content">
      <wj-input-date id="dfd_PhotoSchedule" class="position-relative" [(text)]="photoSchedule"
      [isRequired]="false" [value]="null" [isDisabled]="disabledFlag"
      (input)="eventImageInfoDetailCHANGE.emit($event)" [placeholder]="''"
      forcedEnabledMode="false" [tabindex]="0" #dfd_PhotoSchedule></wj-input-date>
    </div>

    <label class="list-input-title">撮影場所</label>
    <div class="list-input-content">
      <app-studio-master-combo-box id="cmb_PhotoStudioId" [forcedEnabledMode]="'false'"
      [tabindex]="0" #cmb_PhotoStudioId [subid]="'cmb_PhotoStudioId'" [disabled]="disabledFlag"
      (change)="eventImageInfoDetailCHANGE.emit($event)">
    </app-studio-master-combo-box>
    </div>

    <label class="list-input-title">作成指示日</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageInstructDate" #lbl_ImageInstructDate class="date" value="{{imageInstructDate}}" readonly>
    </div>

    <label class="list-input-title">画像ファイル登録日</label>
    <div class="list-input-content">
      <input type="text" id="lbl_FileRegistDate" #lbl_FileRegistDate class="date" value="{{fileRegistDate}}" readonly>
    </div>

    <label class="list-input-title">JPGファイル更新日付</label>
    <div class="list-input-content">
      <input type="text" id="lbl_JpgUpdateDate" #lbl_JpgUpdateDate class="date" value="{{ jpgUpdateDate }}" readonly>
    </div>

    <label class="list-input-title">画像キャプション</label>
    <div class="list-input-content">
      <app-text-area [fullOnly]="true" id="txi_Caption" [forcedEnabledMode]="'false'"
      [verticalScrollPolicy]="'on'" [horizontalScrollPolicy]="'off'" [tabindex]="0" [maxChars]="50"
      [restrict]="'[ -￮]'" #txi_Caption [subid]="'txi_Caption'" [disabled]="disabledFlag"
      (input)="eventImageInfoDetailCHANGE.emit($event)" [displayCountField]="false" [(ngModel)]="caption">
    </app-text-area>
    </div>

  </div>
</div>